import React, { ReactNode } from "react";
import s from "./Property.module.scss";
import Container from "../../../components/common/tools/Container/Container";

export interface IProperty {
  name: string;
  description: string | ReactNode;
  isRequired: boolean;
  type: string;
  examples?: ReactNode;
  defaultValue?: string;
}

export function Property({name, description, isRequired, type, examples, defaultValue}: IProperty) {
  return <div className={s.propertyContainer} id={`property_${name}`}>
    <div className={s.propertyNameContainer}>
      <span className={s.propertyName}>{name}</span>
      <span
        className={s.backToTopLink}
        onClick={() => {
          const anchor = document.getElementById(`component_description`);
          if (anchor) {
            anchor.scrollIntoView({ behavior: "smooth" });
          }
        }}
      >back to top</span>
    </div>

    <span className={s.attributeLabel}>Type</span>: {type}
    <br />
    <span className={s.attributeLabel}>Required</span>: {isRequired ? <span className={s.requiredIndicator}>Yes</span> : "No"}
    <br />
    <span className={s.attributeLabel}>Default value</span>: { !defaultValue ? "None" : defaultValue}

    <div className={s.propertyDescription}>{description}</div>

    {
      examples
        ?
        <div className={s.examplesContainer}>{examples}</div>
        : null
    }
  </div>;
}
